import { GlobalStyle, Container } from "../../common/styles/global-style"
import { urlsPages } from "../../common/urls/urls-pages"
import { ButtonPrimary, Logo } from "../../common"
import { Description, Title, Wrapper } from "./style"

import { useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { Load } from "../../common/load/load"
import { BackedApi } from "../../config/urls/Api"
import Swal from "sweetalert2"

export const ValidateEmail = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setLoading(true);

    const activeAccount = async () => {
      try {
        const token = searchParams.get('token');
        const { url, method } = BackedApi.ActiveAccount(token ?? "");
        const response = await fetch(url, {
          method: method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (response.status !== 200) {
          throw new Error('Erro ao confirmar conta');
        }
        setLoading(false);
      } catch (error) {
        setFailed(true);
        setLoading(false);
        Swal.fire({
          title: 'Error!',
          text: 'Erro ao confirmar a conta, tente novamente mais tarde',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    }
    activeAccount();
  }, [searchParams]);

  return (
    <>
      <GlobalStyle />
      <Container>
        {loading && <Load />}
        <Wrapper>
          <Logo margintop="0" marginbottom="80px" />
          {failed && (
            <Description>
              Erro ao confirmar a conta, tente novamente mais tarde
            </Description>
          )}
          {!failed && (
            <>
              <Title>Cadastro confirmado</Title>
              <Description>
                Sua conta foi verificada com sucesso.
                Faça o login para começar a criar os treinos.
              </Description>
            </>
          )}
          <ButtonPrimary
            margintop="80px"
            marginbottom="30px"
            goToPage={urlsPages.signin}
          >
            Ir para login →
          </ButtonPrimary>
        </Wrapper>
      </Container>
    </>
  )
}
